import type { FaireProductEntity } from "../../entity_types/product";

export const p_437xdh677d: FaireProductEntity = {
  token: "p_437xdh677d",
  type: "product",
  name: "DAPPLED LIGHT",
  brandToken: "b_sbb9hxmx99",
  brandName: "Touchy Coffee",
  imageUrl:
    "https://cdn.faire.com/fastly/6dac50454384a709365b87cedb6c500fa686268895613b4387d27b4da73e2d4b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da8736b1b4a0c703eed7a564e3938e62f91bf8b32698ee3eef75c47c0c33d05b.jpeg",
    "https://cdn.faire.com/fastly/d60f9aad93e59e4dc7325c42d8c59fd8bb467cdb7e92d5fd0521103c8cfddb79.jpeg",
    "https://cdn.faire.com/fastly/165b37347282191207c2c1459db138da02d037881669085eac43b6ce998d1411.jpeg",
  ],
  priceDollars: 33,
  description:
    "Good For: Hot Coffee\nTaste Notes: Coffee Cake, Round, Reflection\nBrew It: Drip, batch, or pourover. Extra credit if you sip barefoot standing in a sun spot.\nSizing: Available in 12oz retail bags or 2lb + 5lb bulk bags for brewing!\n\nGood morning, sunbeam. Remember that perfect Saturday when the curtains fluttered, the playlist was vinyl-soft, and the cat did slowmo stretches across the floorboards? That is Dappled Light. We built it for the slow-sipping, easy mornings.\n\nThe origin rotates, but the vibe never budges: soft florals, honeyed toast sweetness, a breeze of citrus that feels like sunrise on your taste buds.\n\n𝐕𝐢𝐛𝐞 𝐍𝐨𝐭𝐞𝐬:\n• Golden Hour Glow\n• Dewy Wildflower Meadow\n• Crème Brûlée Soirée\n\nP.S.\nDappled Light is part of our evergreen lineup. Always available, always soft and breezy. The coffee inside will rotate with the seasons, but the vibe you love will stay put. Each bag ships with a sticker naming the current single origin.",
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:05.954Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
